import React, { useCallback } from 'react'
import { useApp } from '../../../context/AppProvider'
import { isEmpty } from '../../../services/common'
import { icon } from '../../../services/icon'

const Input = ({ searchValue, selectedCity, setSelectedCity, setSearchValue }) => {
    const { valueLocation, setValueLocation } = useApp()

    const onChangeValue = useCallback((e) => {
        setSearchValue(e.target.value)
    }, [])

    const clearValue = useCallback(() => {
        setValueLocation({})
        setSearchValue('')
    }, [setValueLocation, setSearchValue])

    return (
        <div className="baseocom-relative">
            <input
                disabled={valueLocation?.city}
                type="text"
                value={searchValue || valueLocation?.city || ''}
                placeholder=""
                onChange={onChangeValue}
                className="disabled:baseocom-opacity-100"
            />
            <div className="baseocom-content-icon">
                {!isEmpty(valueLocation) || !isEmpty(searchValue) ? (
                    <div onClick={clearValue} className="baseocom-cursor-pointer">
                        {icon('close')}
                    </div>
                ) : null}
                {icon('magnifying-glass')}
            </div>
        </div>
    )
}

export default Input
